<template>
  <div class="separator separator__size--full color--dw" />
</template>

<style lang="scss" scoped>
.separator.separator  {
  margin: 24px 0;
}
</style>